<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form 
        layout="inline"
        ref="formSearch"
        :autoFormCreate="(form)=>{this.form = form}">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="客户简称" fieldDecoratorId="tenancyName">
              <a-input placeholder="" v-model="tenancyName"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="客户名称" fieldDecoratorId="name">
              <a-input placeholder="" v-model="name"/>              
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="激活状态" fieldDecoratorId="isActive">
                <a-select placeholder="全部" default-value="3" v-model="isActive">
                  <a-select-option value="3">全部</a-select-option>
                  <a-select-option value="1">使用中</a-select-option>
                  <a-select-option value="2">已禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="到期日期" fieldDecoratorId="creationDates">
                <a-range-picker style="width: 100%" v-model="creationDates" :placeholder="['开始日期','结束日期']"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="联系手机" fieldDecoratorId="mobile">
                <a-input placeholder="" v-model="mobile"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="联系人员" fieldDecoratorId="contact">
                <a-input placeholder="" v-model="contact"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="query">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetSearch">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
        <div class="table-operator">
          <a-button type="primary" @click="addTenant">新增</a-button>
        </div>
      </a-form>
    </div>
    <a-table
      ref="list"
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >      
      <template slot="isActive" slot-scope="active">
        <a href="javascript:;">{{ active?'使用中':'已禁用' }}</a>
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="record.isActive">
              <a href="javascript:;" @click="disabledTenant(record)">禁用</a>
            </a-menu-item>
            <a-menu-item v-if="!record.isActive">
              <a href="javascript:;" @click="activeTenant(record)">启用</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="handlePayClick(record)">续费</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="handlePayListClick(record)">续费记录</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>
    <edit-tenant :visible="editModalVisible" @change="editModalChange"></edit-tenant> 
    <payment :visible="payModalVisible" @change="payModalChange"></payment>  
    <payment-list ref="paylist" v-model="paylistModalVisible"></payment-list> 
  </a-card>
</template>
<script>
import { mapActions,mapState,mapMutations } from 'vuex'
import STable from '@/components/table/'
import EditTenant from '@/components/TenantList/EditTenant'
import Payment from './Payment'
import PaymentList from './PaymentList'

export default {
  components:{
    STable,
    EditTenant,
    Payment,
    PaymentList
  },
  data(){
    return{
      description: '创建客户、管理客户及付费情况。',
      tenancyName:'',
      name:'',
      isActive:'',
      creationDates:[],
      mobile:'',
      contact:'',
      advanced:false,
      form: null,
      editModalVisible:false,
      payModalVisible:false,
      confirmLoading:false,
      paylistModalVisible:false,
      columns:[{
        title: '客户简称',
        dataIndex: 'tenancyName',
        key: 'tenancyName',
        sorter: true,
      },{
        title: '客户名称',
        dataIndex: 'name',
        key: 'name', 
        sorter: true,
      },{
        title: '联系人',
        dataIndex: 'contact',
        key: 'contact', 
        sorter: true,
      },{
        title:'手机',
        dataIndex:'mobile',
        key:'mobile',
        sorter: true,
      },{
        title:'使用状态',
        dataIndex:'isActive',
        key:'isActive',
        scopedSlots: { customRender: 'isActive' },
        sorter: true,
      },{
        title:'到期时间',
        dataIndex:'expireDate',
        key:'expireDate',
        customRender: (text,row)=>{
          return row.expireDate?this.datestr(row.expireDate):'无限制'
        },
        sorter: true,
      },{
        title:'价格',
        dataIndex:'price'
      },{
        title:'总费用',
        dataIndex:'totalAmt'
      },{
        title:'合作年数',
        dataIndex:'totalYears'
      },{
        title: '操作',
        key: 'action',
        width: '150px',
        scopedSlots: { customRender: 'action' },
      }]
    }
  },
  computed:{
    ...mapState({
      data:state=>state.tenant.data,
      loading:state=>state.tenant.loading,
      pagination:state=>state.tenant.pagination,
      sorter:state=>state.tenant.sorter
    })
  },
  methods:{
    ...mapActions('tenant',['getAll','getEditions','disabled','active']),
    ...mapMutations('tenant',['edit','setSorter']),
    handleTableChange(pagination,filters, sorter){
      const filter={
        tenancyName:this.tenancyName,
        name:this.name,
        mobile:this.mobile,
        contact:this.contact
      }
      if(this.creationDates.length==2){
        filter.startTime=this.creationDates[0].format('YYYY-MM-DD')
        filter.endTime=this.creationDates[1].format('YYYY-MM-DD')
      }else{
        filter.startTime=null
        filter.endTime=null
      }
      if(sorter){
        this.setSorter(sorter)
      }else{
        this.setSorter({})
      }     
      const page={...pagination,...filter}      
      if(this.isActive==='1'){
        page.isActive=true
      }else if(this.isActive==='2'){
        page.isActive=false
      }else{
        page.isActive=null
      }     
      this.getAll(page)
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    query(){
      this.form.validateFields((error,values)=>{
        if(!error){       
          this.tenancyName=values.tenancyName
          this.name=values.name
          this.contact=values.contact
          this.mobile=values.mobile
          this.isActive=values.isActive
          if(!values.creationDates){
            this.creationDates=[]
          }else{
            this.creationDates=values.creationDates
          }
        }
      })
      let sorter={}
      if(this.$refs.list.$children[0].sSortColumn){
        sorter={
          field:this.$refs.list.$children[0].sSortColumn.key,
          order:this.$refs.list.$children[0].sSortOrder
        }
      }
      const page={...this.$refs.list.pagination}
      page.current=1
      this.handleTableChange(page,null,sorter)
    },
    refresh(){
      let sorter={}
      if(this.$refs.list.$children[0].sSortColumn){
        sorter={
          field:this.$refs.list.$children[0].sSortColumn.key,
          order:this.$refs.list.$children[0].sSortOrder
        }
      }
      const page={...this.$refs.list.pagination}
      this.handleTableChange(page,null,sorter)
    },
    resetSearch(){
      this.form.resetFields()
    },
    handleEdit(tenant){
      this.edit(tenant)
      this.editModalVisible=true
    },
    addTenant(){
      this.edit({schoolQty:1,isActive:true})
      this.editModalVisible=true
    },
    editModalChange(visible){
      this.editModalVisible=visible
      this.refresh()
    },
    editionName(editionId){
      for(var i=0;i<this.editions.length;i++){
        if(this.editions[i].id===editionId){
          return this.editions[i].displayName
        }
      }
    },
    async disabledTenant(tenant){
      this.$confirm({
        title: '是否禁用?',
        content: '禁用后该学校的所有用户都不能登录，数据将会完整保留 、',
        onOk:async ()=> {
          await this.disabled(tenant)
        }
      })
      
    },
    async activeTenant(tenant){
      await this.active(tenant)
    },
    handlePayClick(tenant){
      this.edit(tenant)
      this.payModalVisible=true
    },
    payModalChange(visible){
      this.payModalVisible=visible
      this.refresh()
    },
    async handlePayListClick(tenant){
      await this.$refs.paylist.getPaylist(tenant)
      this.paylistModalVisible=true
    }
  },
  mounted(){
    this.query()
    this.setSorter({})
  }
}
</script>

